import React, { useRef, useState, useEffect } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import Category from './Category';

function Categories() {
  const [categories, setCategories] = useState([]);
  const c = useFetch('https://www.fabrilum.com.ar/backend/getAplicaciones.php');

  return (
    <div className={`w-5/6 px-4  m-auto pb-8`}>
      <p className="font-extralight text-2xl border-solid mb-4 border-t-2 py-4 border-gray-100">
        Explorar por categorias
      </p>
      <div className="flex w-full flex-wrap justify-between">
        {c.data &&
          c.data[0].map((cat, i) => {
            return (
              <Category data={cat} index={i} delay={`delay-${i * 100 + 100}`} />
            );
          })}
        <Category
          delay={`delay-400`}
          data={{ nombre: 'Ver Todas', id: 3, imagen: 'todas.jpg' }}
        />
      </div>
    </div>
  );
}
export default Categories;
